// src/components/SaveManager.js
import { loadSlots, deleteSlot } from '../features/game/saveSlots';

export default function SaveManager({ onLoad, onNew }) {
  const slots = loadSlots();

  return (
    <div className="page">
      <h1 style={{marginBottom:10}}>Select Save Slot</h1>
      <div className="save-grid">
        {Array.from({length:3}).map((_,i)=>{
          const s = slots[i];
          return (
            <div key={i} className="card save-slot">
              <div className="save-head">Slot {i+1}</div>
              {s ? (
                <>
                  <div className="save-main">
                    <div><b>{s.hero?.name}</b> — {s.hero?.cls}</div>
                    <div>Lv {s.progress?.level} · Wave {s.progress?.wave} · Gold {s.progress?.gold}</div>
                  </div>
                  <div className="row">
                    <button className="btn primary" onClick={()=>onLoad(s,i)}>Load</button>
                    <button className="btn ghost" onClick={() => { deleteSlot(i); window.location.reload(); }}>Delete</button>
                  </div>
                </>
              ) : (
                <>
                  <div className="save-main" style={{opacity:.8}}>Empty</div>
                  <button className="btn primary" onClick={()=>onNew(i)}>New Game</button>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
